(() => {
  'use strict';
  if (window.rhAllBlogsInit) { window.rhAllBlogsInit(document); return; }
  const query = `query RareHillsArticles($after: String) {
    articles(first: 12, after: $after, sortKey: PUBLISHED_AT, reverse: true) {
      nodes { id handle title excerpt(truncateAt: 170) publishedAt
        blog { handle title } image { url(transform: {maxWidth: 900}) altText width height }
      }
      pageInfo { hasNextPage endCursor }
    }
  }`;
  function init(scope) {
    scope.querySelectorAll('[data-rh-all-blogs]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const grid = root.querySelector('[data-articles]');
      const status = root.querySelector('[role="status"]');
      const more = root.querySelector('[data-more]');
      const retry = root.querySelector('[data-retry]');
      let cursor = null, busy = false, hasMore = true;
      const seen = new Set();
      function el(tag, cls, text) {
        const node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text != null) node.textContent = text;
        return node;
      }
      function card(a) {
        const url = (root.dataset.root || '/').replace(/\/?$/, '/') + 'blogs/' + encodeURIComponent(a.blog.handle) + '/' + encodeURIComponent(a.handle);
        const item = el('article', 'directory-article-card');
        const cover = el('a', 'directory-article-card__image');
        cover.href = url; cover.setAttribute('aria-label', 'Read ' + a.title);
        if (a.image) {
          const img = el('img'); img.src = a.image.url; img.alt = a.image.altText || a.title;
          img.loading = seen.size < 3 ? 'eager' : 'lazy'; img.decoding = 'async';
          if (a.image.width) img.width = a.image.width;
          if (a.image.height) img.height = a.image.height;
          cover.append(img);
        } else {
          cover.classList.add('rh-journal__placeholder');
          cover.append(el('span', '', 'RARE HILLS JOURNAL'), el('span', '', '↗'));
        }
        const body = el('div', 'directory-article-card__body');
        body.append(el('span', 'rh-journal__topic', a.blog.title));
        const meta = el('p', 'directory-article-meta'), date = el('time');
        date.dateTime = a.publishedAt;
        date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {day:'numeric',month:'long',year:'numeric'}).format(new Date(a.publishedAt));
        meta.append(date); body.append(meta);
        const heading = el('h2'), title = el('a', '', a.title); title.href = url; heading.append(title); body.append(heading);
        if (a.excerpt) body.append(el('p', '', a.excerpt));
        const link = el('a', 'directory-read-link', 'Read article'); link.href = url;
        const arrow = el('span', '', '↗'); arrow.setAttribute('aria-hidden','true'); link.append(arrow); body.append(link);
        item.append(cover,body); return item;
      }
      async function load() {
        if (busy || !hasMore) return;
        busy = true; more.disabled = true; retry.hidden = true;
        root.setAttribute('aria-busy','true'); status.hidden = false; status.textContent = 'Loading the latest articles…';
        const controller = new AbortController(); const timer = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(root.dataset.endpoint, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query,variables:{after:cursor}}),signal:controller.signal});
          if (!response.ok) throw new Error('Articles unavailable');
          const payload = await response.json();
          if (payload.errors?.length || !payload.data?.articles) throw new Error('Articles unavailable');
          const data = payload.data.articles;
          const fragment = document.createDocumentFragment();
          const added = [];
          for (const a of data.nodes) if (!seen.has(a.id)) { fragment.append(card(a)); added.push(a.id); }
          grid.append(fragment); added.forEach(id => seen.add(id));
          cursor = data.pageInfo.endCursor; hasMore = data.pageInfo.hasNextPage;
          more.hidden = !hasMore;
          status.textContent = seen.size ? `${seen.size} articles · Latest first` : 'New stories are on the way. Check back soon.';
        } catch (error) {
          status.textContent = 'Articles could not load. Please try again.';
          retry.hidden = false;
        } finally {
          clearTimeout(timer); busy = false; more.disabled = false; root.removeAttribute('aria-busy');
        }
      }
      more.addEventListener('click', load); retry.addEventListener('click', load); load();
    });
  }
  window.rhAllBlogsInit = init;
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
